import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {useSelector} from 'react-redux';
import {
  Icon, Label, Menu,
} from 'semantic-ui-react';
import {closeMenu, openMenu} from './actions';
import { getCart } from '../../views/Cart/reducer';
import { setPopupOpen } from "../../views/EditProfile/actions";

import {SERVICE_TASK_LEVEL_PREPARING, SERVICE_TASK_LEVEL_WORKING} from "../../config/config";

import UserLogin from "../UserLogin";
import HomeIconAsia from '../../icons/home-icon-red.svg';
import HomeIconGras from '../../icons/home-icon-green.svg'
import HomeIcon from '../../icons/home-icon-white.svg';

import TimetableIcon from '../../icons/timetable-icon-white.svg';
import TimetableIconAsia from '../../icons/timetable-icon-red.svg';
import TimetableIconGras from '../../icons/timetable-icon-green.svg';

import BookmarkIcon from '../../icons/bookmark-icon-white.svg';
import BookmarkIconAsia from '../../icons/bookmark-icon-red.svg';
import BookmarkIconGras from '../../icons/bookmark-icon-green.svg';

import AsiameetIcon from '../../icons/meet-icon-white.svg';
import AsiameetIconAsia from '../../icons/meet-icon-red.svg';
import AsiameetIconGras from '../../icons/meet-icon-green.svg';

import ProfileIcon from '../../icons/profile-icon-white.svg';
import ProfileIconAsia from '../../icons/profile-icon-red.svg';
import ProfileIconGras from '../../icons/profile-icon-green.svg';

import {openAuth} from "../NavTopBar/actions";
import {isAuthVisible} from "../NavTopBar/reducer";
import {getForums} from "../../views/CongressAE2024/BusinessProgram/reducer";
import {getLanguage} from "../LanguageModal/reducer";
import {getTypeExhibition} from "../../views/Home/reducer";
import translations from "../LanguageModal/translations";
import UnloginPopup from "../UnloginPopup";

export default function NavBottomBar (props) {

  const {menuVisible, dispatch, navigate, token, location, isLoggedIn} = props;

  const authVisible = useSelector((state) => isAuthVisible(state.navtopbar));
  const isFormChanged = useSelector((state) => state.formReducer.isFormChanged);
  const forums = useSelector((state) => getForums(state.forums));
  const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

  const [openLogin, setOpenLogin] = useState(false);

  const HomeIconActive = {
    asia: HomeIconAsia,
    gras: HomeIconGras,
  }

  const TimetableIconActive = {
    asia: TimetableIconAsia,
    gras: TimetableIconGras,
  }

  const BookmarkIconActive = {
    asia: BookmarkIconAsia,
    gras: BookmarkIconGras,
  }

  const AsiameetIconActive = {
    asia: AsiameetIconAsia,
    gras: AsiameetIconGras,
  }

  const ProfileIconActive = {
    asia: ProfileIconAsia,
    gras: ProfileIconGras,
  }

    function showSidebar(e) {
    e.stopPropagation();
    dispatch( menuVisible ? closeMenu() : openMenu());
  }

  const language = useSelector(getLanguage);
  const t = (key) => {
    const languageString = language[0]+language[1];
    const translation = translations[languageString];
    return translation ? translation[key] || key : key;
  };

  const handleAsiaClick = () => {
    if(!token) {
      setOpenLogin(true);
    } else {
      navigate('/asiameet')
    }
  }

  return (
    <>
      { location.pathname === '/auth' || location.pathname === '/registration' || location.pathname === '/confirmation-code'
        ? ""
        : <Menu
              fluid
              secondary
              id="nav-bottom-bar"
              className="nav-bottom-bar"
              fixed="bottom"
              icon="labeled"
              inverted
          >
              <Menu.Item className="shop-icon-item" onClick={() => {isFormChanged && location.pathname === '/profile/edit' ? dispatch(setPopupOpen("/")) : navigate("/")}}>
                  <img className="shop-icon" src={

                    location.pathname === '/' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024/description-congress' ||
                    location.pathname === '/description-congress' ||
                    location.pathname === '/archive-events' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2023' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2023/business-program-archive' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2023/cultural-program' ||
                    location.pathname === '/business-program' ||
                    location.pathname === '/exposition' ||
                    location.pathname === '/cultural-program' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2023/exponents' ||
                    location.pathname === '/hackathon-asiaexpo' ||
                    location.pathname === '/business-mission-asiaexpo' ||
                    location.pathname === '/events-asiaexpo' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024/cultural-program' ||
                    location.pathname === '/scan' ||
                    location.pathname === '/ticket' ||
                    location.pathname === '/travel-plan' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024/exposition' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024/business-program' ||
                    location.pathname === '/archive-events/congress-asiaexpo-2024/exponents' ||
                    location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/exposition/') ||
                    location.pathname.startsWith('/exposition/') ||
                    location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/business-program/event/') ||
                    location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/exponents/exponents-card/') ||
                    location.pathname.startsWith('/archive-events/congress-asiaexpo-2023/business-program-archive/event/') ||
                    location.pathname.startsWith('/business-program/event/') ||
                    location.pathname === '/gras/business-program' ||
                    location.pathname === '/gras' ||
                    location.pathname === '/gras/description-congress' ||
                    location.pathname.startsWith('/archive-events/congress-asiaexpo-2023/exponents/exponents-card/')
                        ? HomeIconActive[typeExhibition] : HomeIcon
                  } alt=""/>
                  <div className="shop-text-item">{t('main')}</div>
              </Menu.Item>
              <Menu.Item name="tasks" className="shop-icon-item" onClick={() => {isFormChanged && location.pathname === '/profile/edit' ? dispatch(setPopupOpen()) : navigate("/schedule")}}>
                  <img className="shop-icon" src={location.pathname === '/schedule' ? TimetableIconActive[typeExhibition] : TimetableIcon} alt=""/>
                  <div className="shop-text-item">{t('timetable')}</div>
              </Menu.Item>
              <Menu.Item className="shop-icon-item" onClick={() => {isFormChanged && location.pathname === '/profile/edit' ? dispatch(setPopupOpen("/bookmarks")) : navigate("/bookmarks")}}>
                  <img className="shop-icon" src={location.pathname === '/bookmarks' ? BookmarkIconActive[typeExhibition] : BookmarkIcon} alt=""/>
                  <div className="shop-text-item">{t('bookmarks')}</div>
              </Menu.Item>
              <Menu.Item className="shop-icon-item" onClick={() => {isFormChanged && location.pathname === '/profile/edit' ? dispatch(setPopupOpen("/asiameet")) : handleAsiaClick()}}>
                  <img className="shop-icon" src={
                    location.pathname === '/asiameet' ||
                    location.pathname === '/asiameet/form-meeting' ||
                    location.pathname === '/grasmeet'
                        ? AsiameetIconActive[typeExhibition] : AsiameetIcon} alt=""/>
                  <div className="shop-text-item">AsiaMeet</div>
              </Menu.Item>

              <Menu.Item className="shop-icon-item" onClick={
                isLoggedIn
                    ? (isFormChanged && location.pathname === '/profile/edit'
                        ? () => dispatch(setPopupOpen("/profile"))
                        : () => navigate("/profile"))
                    : () => {
                        if (!authVisible)
                          dispatch(openAuth())
                      }
              }>
                <UserLogin showModal={authVisible} {...props}/>
                  <img className="shop-icon" src={
                    location.pathname === '/profile' ||
                    location.pathname === '/profile/edit' ||
                    location.pathname === '/faq' ||
                    location.pathname === '/support' ||
                    location.pathname === '/profile/company' ||
                    location.pathname === '/profile/exponents'
                        ? ProfileIconActive[typeExhibition] : ProfileIcon
                  } alt=""/>

                  <div className="shop-text-item">{isLoggedIn ? t('profile') : t('login')}</div>
              </Menu.Item>
              <UnloginPopup open={openLogin} setOpen={setOpenLogin} text={t('onlyReg')} />
          </Menu>
}


    </>
  );
}
